import { render, staticRenderFns } from "./visit-action-history.vue?vue&type=template&id=7c8cd243&scoped=true"
import script from "./visit-action-history.vue?vue&type=script&lang=ts"
export * from "./visit-action-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8cd243",
  null
  
)

export default component.exports